import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import BatchModalContent from './Components/BatchModalContent';

import './BatchModal.custom.scss';
import './BatchModal.theme.scss';

function BatchModal(props) {
  const { initialize, batchFile } = props;

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!batchFile) {
    return null;
  }

  return (
    <GeneralDialogLayout
      {...props}
      className="react-dialogs-scrollable batch-modal"
      size="lg"
      header={
        <div className="batch-modal__header">
          <h4>Batch Query file loaded</h4>
        </div>
      }
      headerClassName="no-border"
      footerClassName="no-border"
      footer={<div className="batch-modal__footer" />}>
      <BatchModalContent {...props} />
    </GeneralDialogLayout>
  );
}

BatchModal.propTypes = {
  initialize: PropTypes.func.isRequired,
  batchFile: PropTypes.shape({ filename: PropTypes.string, validQueriesCount: PropTypes.number }),
};

export default BatchModal;
